import { BACK_TYPE } from '@abiglobalhealth/go-types'
import { useTranslation } from 'react-i18next'

import { ArrowLeft } from '@/components/icons/ArrowLeft'
import { useLoading } from '@/hooks/useLoading'
import { useNavigate } from '@/hooks/useNavigate'
import { useReminder } from '@/hooks/useReminder'
import { useStep } from '@/hooks/useStep'
import { isRTL } from '@/locale/utils'
import { cn } from '@/utils/tailwind'

export const BackButton = () => {
  const { t } = useTranslation()
  const { navigateBack } = useNavigate()
  const { setReminderSet } = useReminder()
  const { loading } = useLoading()
  const { currentStep } = useStep()

  return (
    <button
      data-testid="back-button"
      title={t('back') || 'back'}
      className="flex items-center gap-2 disabled:opacity-50"
      disabled={loading}
      onClick={async () => {
        setReminderSet(false)

        await navigateBack()
      }}
    >
      <ArrowLeft className={cn('text-header-text h-5', isRTL() && 'rotate-180 transform')} />
      {currentStep?.backButton === BACK_TYPE.LONG && <span className="text-header-text ml-2">{t('back')}</span>}
    </button>
  )
}
